import React, { useState } from 'react';
import InfoIconButton from '../../InfoIconButton';

function AddressCommunicationSection({
  formData,
  handleChange,
  counties = [],
  cities = [],
  primaryContactPhone = '',
  primaryContactEmail = '',
  onPrimaryContactPhoneEmailChange,
  hasPrimaryContact = false,
  canEditPrimaryContactComm = true,
}) {
  const handleStateChange = (e) => {
    const value = e.target.value.toUpperCase().slice(0, 2);
    handleChange({ target: { name: 'state', value } });
  };

  const addrDisabled = !hasPrimaryContact;
  const addrReadOnly = hasPrimaryContact;
  const [hintVisible, setHintVisible] = useState(true);

  return (
    <div className="form-section">
      <h3 className="section-title">
        Address &amp; Communication (primary contact)
        <InfoIconButton
          onClick={() => setHintVisible(v => !v)}
          ariaExpanded={hintVisible}
          ariaControls="addr-comm-hint"
          ariaLabel="Show address and communication note"
          ariaLabelExpanded="Hide address and communication note"
        />
      </h3>

      {hintVisible && (
        <div id="addr-comm-hint">
          {!hasPrimaryContact && (
            <p className="form-hint address-comm-no-contact-hint">
              Choose a primary contact in the Contacts &amp; Providers section below — address and communication fields are stored on the contact record and will populate here once one is linked.
            </p>
          )}
          {hasPrimaryContact && (
            <p className="form-hint address-comm-no-contact-hint">
              These fields come from the primary contact record and are read-only here. To edit address, phone, or email, use the eye icon next to the contact in the Contacts &amp; Providers section below.
            </p>
          )}
        </div>
      )}

      <div className={`form-grid${addrDisabled ? ' address-comm-grid--pending' : ''}`}>
        <div className="form-group">
          <label>Street Address 1 *</label>
          <input
            type="text"
            name="street_1"
            value={formData.street_1 || ''}
            onChange={handleChange}
            maxLength={255}
            disabled={addrDisabled || addrReadOnly}
            required={!addrDisabled}
          />
        </div>

        <div className="form-group">
          <label>Street Address 2</label>
          <input
            type="text"
            name="street_2"
            value={formData.street_2 || ''}
            onChange={handleChange}
            maxLength={255}
            disabled={addrDisabled || addrReadOnly}
          />
        </div>

        <div className="form-group">
          <label>City *</label>
          <select
            name="city_id"
            value={formData.city_id || ''}
            onChange={handleChange}
            disabled={addrDisabled || addrReadOnly}
            required={!addrDisabled}
          >
            <option value="">-- Select City --</option>
            {cities.map((city) => (
              <option key={city.id} value={city.id}>
                {city.city}
              </option>
            ))}
          </select>
          {!formData.city_id && formData.city && String(formData.city).trim() !== '' && (
            <p className="form-hint" style={{ marginTop: '0.35rem', fontSize: '0.9em', color: '#555' }}>
              Imported address city (not linked to lookup yet): <strong>{formData.city}</strong>.
              Run backfill or re-run clients ETL to set City; or pick the matching city above.
            </p>
          )}
        </div>

        <div className="form-group">
          <label>State *</label>
          <input
            type="text"
            name="state"
            value={formData.state || ''}
            onChange={handleStateChange}
            maxLength={2}
            placeholder="IL"
            style={{ textTransform: 'uppercase' }}
            disabled={addrDisabled || addrReadOnly}
            required={!addrDisabled}
          />
        </div>

        <div className="form-group">
          <label>ZIP Code *</label>
          <input
            type="text"
            name="zip"
            value={formData.zip || ''}
            onChange={handleChange}
            maxLength={10}
            disabled={addrDisabled || addrReadOnly}
            required={!addrDisabled}
          />
        </div>

        <div className="form-group">
          <label>County *</label>
          <select
            name="county_id"
            value={formData.county_id || ''}
            onChange={handleChange}
            disabled={addrDisabled || addrReadOnly}
            required={!addrDisabled}
          >
            <option value="">-- Select County --</option>
            {counties.map((county) => (
              <option key={county.id} value={county.id}>
                {county.county}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="primary-contact-phone">Phone</label>
          <input
            id="primary-contact-phone"
            type="tel"
            name="primary_contact_phone"
            value={primaryContactPhone}
            onChange={(e) => onPrimaryContactPhoneEmailChange?.('phone', e.target.value)}
            disabled={true}
          />
        </div>

        <div className="form-group">
          <label htmlFor="primary-contact-email">Email</label>
          <input
            id="primary-contact-email"
            type="email"
            name="primary_contact_email"
            value={primaryContactEmail}
            onChange={(e) => onPrimaryContactPhoneEmailChange?.('email', e.target.value)}
            disabled={true}
          />
        </div>
      </div>

      <div className="client-form-communication-note-block">
        <label htmlFor="communication-note">Communication note</label>
        <textarea
          id="communication-note"
          name="communication_note"
          className="client-form-communication-note-textarea"
          value={formData.communication_note || ''}
          onChange={handleChange}
          rows={1}
          maxLength={8000}
        />
      </div>
    </div>
  );
}

export default AddressCommunicationSection;
